type LogContext = Record<string, string | number | boolean | null | undefined>;
type LogLevel = "debug" | "info" | "warn" | "error";

const sensitiveKeyPattern = /address|key|secret|token|account|password/i;

export function sanitizeLogContext(context: LogContext = {}) {
  const sanitized: Record<string, string | number | boolean | null> = {};
  for (const [key, value] of Object.entries(context)) {
    if (value === undefined || sensitiveKeyPattern.test(key)) continue;
    sanitized[key] = value;
  }
  return sanitized;
}

export function createDashboardLogger(component: string) {
  function write(level: LogLevel, message: string, context: LogContext = {}) {
    const payload = JSON.stringify({
      level,
      component,
      message,
      context: sanitizeLogContext(context),
    });
    const writer =
      level === "error" ? console.error : level === "warn" ? console.warn : console.info;
    writer(payload);
  }

  return {
    debug: (message: string, context?: LogContext) => write("debug", message, context),
    info: (message: string, context?: LogContext) => write("info", message, context),
    warn: (message: string, context?: LogContext) => write("warn", message, context),
    error: (message: string, context?: LogContext) => write("error", message, context),
  };
}
